import AppConstants from '../Constants/AppConstants';

const draftKeyFor = props => {
  const routeScope = props?.isEdit
    ? `edit:${props?.params?.listingID || 'unknown'}`
    : `new:${props?.type || 'listing'}`;
  return `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:listings:${routeScope}`;
};

const cleanText = (value, limit = 5000) =>
  typeof value === 'string' || typeof value === 'number'
    ? String(value).slice(0, limit)
    : '';

const cleanIdArray = value =>
  (Array.isArray(value) ? value : []).slice(0, 300).map(item =>
    typeof item === 'object' && item !== null
      ? {
          id: cleanText(item.id ?? item.value, 100),
          name: cleanText(item.name ?? item.label, 300),
          value: cleanText(item.value ?? item.id, 100),
          label: cleanText(item.label ?? item.name, 300),
        }
      : cleanText(item, 100),
  );

const cleanScheduleArray = value =>
  (Array.isArray(value) ? value : []).slice(0, 100).map(item => ({
    startDate: cleanText(item?.startDate, 40),
    startTime: cleanText(item?.startTime, 20),
    endTime: cleanText(item?.endTime, 20),
    slot: cleanText(item?.slot, 20),
    repeatClass: {
      name: cleanText(item?.repeatClass?.name, 100),
      ids: cleanText(item?.repeatClass?.ids, 100),
    },
    timeSlots: (Array.isArray(item?.timeSlots) ? item.timeSlots : []).slice(0, 100).map(slot => ({
      start: cleanText(slot?.start, 20),
      end: cleanText(slot?.end, 20),
    })),
  }));

const cleanAttributeData = value =>
  (Array.isArray(value) ? value : []).slice(0, 300).map(attribute => ({
    id: cleanText(attribute?.id, 100),
    values: (Array.isArray(attribute?.values) ? attribute.values : []).slice(0, 300).map(item =>
      typeof item === 'object' && item !== null
        ? cleanText(item.id ?? item.value ?? item.name, 300)
        : cleanText(item, 300),
    ),
  }));

const safeDraftFromState = state => ({
  titleString: cleanText(state.titleString, 300),
  descriptionString: cleanText(state.descriptionString, 20000),
  slugValue: cleanText(state.slugValue, 300),
  listPriceValue: cleanText(state.listPriceValue, 40),
  stockValue: cleanText(state.stockValue, 40),
  offerPercentage: cleanText(state.offerPercentage, 40),
  maxQuantity: cleanText(state.maxQuantity, 40),
  tags: (Array.isArray(state.tags) ? state.tags : []).slice(0, 100).map(tag => cleanText(tag, 100)),
  selectedCurrencyID: cleanText(state.selectedCurrencyID, 100),
  selectedCurrencyCODE: cleanText(state.selectedCurrencyCODE, 20),
  selectedCategoryID: cleanIdArray(state.selectedCategoryID),
  selectedCategoryArray: cleanIdArray(state.selectedCategoryArray),
  selectedCategory: cleanText(state.selectedCategory, 1000),
  accountID: cleanText(state.accountID, 100),
  metaTitle: cleanText(state.metaTitle, 300),
  metaDescriptionString: cleanText(state.metaDescriptionString, 5000),
  selectedRepeatIndex: Number.isInteger(state.selectedRepeatIndex) ? state.selectedRepeatIndex : -1,
  selectedWeekDay: cleanIdArray(state.selectedWeekDay),
  scheduleArray: cleanScheduleArray(state.scheduleArray),
  selectedSlot: cleanText(state.selectedSlot, 20),
  scheduleStartTime: cleanText(state.scheduleStartTime, 20),
  scheduleEndTime: cleanText(state.scheduleEndTime, 20),
  attributeData: cleanAttributeData(state.attributeData),
  selected_listing_tax_id: cleanText(state.selected_listing_tax?.id, 100),
});

export const listingDraftKey = props => draftKeyFor(props);

export const readListingDraft = key => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return {};
    const value = JSON.parse(window.localStorage.getItem(key) || '{}');
    return value && typeof value === 'object' ? value : {};
  } catch (error) {
    return {};
  }
};

export const writeListingDraft = (key, state) => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    window.localStorage.setItem(key, JSON.stringify(safeDraftFromState(state)));
  } catch (error) {
    // Keep the form usable when browser storage is unavailable or full.
  }
};

export const clearListingDraft = key => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) window.localStorage.removeItem(key);
  } catch (error) {
    // Ignore storage errors after a successful save.
  }
};
